import React from 'react';
import { Card, Stack, Typography } from "@curves/ui-base";
import employeeInBodyInterviewMeasureItems from '@icoach/inbody/employeeInbodyInterview/EmployeeInBodyInterviewMeasureItems';
import { MeasureRecordTable } from '@icoach/inbody/components';
import { isEmpty } from '@util/utils';

const InBodyInterviewMeasureTable = React.forwardRef(({ sourceData: validMeasureData }, ref) => {
    return (
        <Card>
            {!isEmpty(validMeasureData) ? (
                <Card.CardContent>
                    <MeasureRecordTable sourceData={validMeasureData} measureItems={employeeInBodyInterviewMeasureItems} />
                </Card.CardContent>
            ) : (
                <Card.CardContent className={'p-3'}>
                    <Stack justifyContent={'center'} alignItems={'center'}>
                        <Typography variant="h6" className={'font-color-4'}>
                            無相關資料
                        </Typography>
                    </Stack>
                </Card.CardContent>
            )}
        </Card>
    );
});

export default InBodyInterviewMeasureTable;
